import { of } from "rxjs";
import { actionPurchasePointsReceived } from "../../purchase-points-event/actionPurchasePointsEventInfo";
export var networkNoticePurchasePointsUpdateHandler = function (action$, state$, deps) { return function (res) {
    return of(actionPurchasePointsReceived(res));
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/network/handlers/networkNoticePurchasePointsUpdateHandler.ts
// module id = 2015
// module chunks = 3